module.exports = __webpack_public_path__ + "img/ecran facebook.7d9af3cb.png";